module.exports = __webpack_public_path__ + "static/media/Univers-Condensed-Bold.3f362700.otf";